module.exports = __webpack_public_path__ + "img/15.4-gallery.d83ec3b5.jpg";